var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.heroType === 'video')?_c('HeroVideoBackground',{attrs:{"options":_vm.data}}):(_vm.data.showCarousel)?_c('HeroCarousel',{attrs:{"options":_vm.data}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }